import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CheckoutState {
    deliveryType: string;
    paymentMethod: string;
    quantity: number;
    item: {
        id: string;
        name: string;
        description: string;
        price: number;
        quantity: number;
        currency: string;
    };
}

const initialState: CheckoutState = {
    deliveryType: 'pickup',
    paymentMethod: '',
    quantity: 1,
    item: {
        id: '',
        name: '',
        description: '',
        price: 0,
        quantity: 1,
        currency: ''
    }
};

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        setCheckoutData(state, action: PayloadAction<Partial<CheckoutState>>) {
            return { ...state, ...action.payload };
        },
        resetCheckout(state) {
            return initialState;
        }
    }
});

export const { setCheckoutData, resetCheckout } = checkoutSlice.actions;
export default checkoutSlice.reducer;
